
export let DL_APP_GLASS_DIALOGS = "DIALOGS";
export let DL_APP_GLASS_PLAYER = "PLAYER";
export let DL_APP_GLASS_HELPER = "HELPER";